import { mapEnumToOptions } from '@abp/ng.core';

export enum DocumentStatus {
  NotApproved = 0,
  Approved = 1,
}

export const documentStatusOptions = mapEnumToOptions(DocumentStatus);
